import { render } from "./publicLotComponent.vue?vue&type=template&id=b70d8f46"
import script from "./publicLotComponent.vue?vue&type=script&lang=js"
export * from "./publicLotComponent.vue?vue&type=script&lang=js"

import "./publicLotComponent.vue?vue&type=style&index=0&id=b70d8f46&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__